module.exports = __webpack_public_path__ + "static/img/logo.03c999f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business/logo.png
// module id = 34u/
// module chunks = 24